import { useUser } from "contexts";
import { getCollectionWithQuery } from "db/queries";
import { where } from "firebase/firestore";
import { useMemo, useEffect, useState } from "react";

export const useFetchPublic = (COLLECTION_NAME, converter) => {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);

  const { loading: userLoading, profile } = useUser();

  const loading = useMemo(() => {
    return isLoading || userLoading || !data.length;
  }, [isLoading, userLoading, data.length]);

  const filteredData = useMemo(() => {
    return data.filter((item) => item.userId !== profile?._id);
  }, [data?.length, profile?._id]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const values = [true];
        const chunkSize = 30;
        const chunks = [];

        for (let i = 0; i < values.length; i += chunkSize) {
          chunks.push(values.slice(i, i + chunkSize));
        }

        const results = await Promise.all(
          chunks.map((chunk) =>
            getCollectionWithQuery(
              COLLECTION_NAME,
              [where("is_public", "in", chunk)],
              converter
            )
          )
        );

        setData(results.flat());
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (!data.length && !isLoading) {
      fetchData();
    }
  }, [data.length, isLoading]);

  return { data: filteredData, loading, error };
};
